import DomainSuggest from '../../modules/email/domainSuggest';

const domainSuggest = new DomainSuggest();

domainSuggest.enableSuggestion();
